import type { ReactNode } from "react";

import { type LinkComponent, LinkContext } from "./linkContext.js";

/**
 * Routes every in-app link below it through the app's router, so a nav link, a card or a footer
 * link navigates in place instead of reloading the page. Mount once near the root:
 *
 *   const RouterLink: LinkComponent = ({ href, ...props }) => <Link to={href} {...props} />;
 *   <LinkProvider component={RouterLink}>…</LinkProvider>
 *
 * A link given its own `render` keeps it. Without a provider, links are plain anchors.
 */
export function LinkProvider({
  component,
  children,
}: {
  component: LinkComponent;
  children: ReactNode;
}) {
  return <LinkContext.Provider value={component}>{children}</LinkContext.Provider>;
}
